function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "34",
  height: "31",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  stroke: "#00497a",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.544 3.644L21.64.74 3.255 19.125 6.16 22.03c1.572-1.22 3.858-1.092 5.318.368 1.46 1.46 1.588 3.746.368 5.318l2.545 2.545 18.384-18.385L30.23 9.33c-1.572 1.22-3.858 1.092-5.318-.368-1.46-1.46-1.588-3.746-.368-5.318z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.506 9.627l-.707.707-2.512-2.512.707-.707 2.512 2.512zm3.947 3.947l-.707.707-2.512-2.512.707-.707 2.512 2.512zM26.4 17.52l-.707.707-2.512-2.512.707-.707 2.512 2.512z",
  fill: "#00497a"
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "##00497a",
  fill: "#FFF",
  cx: "8.627",
  cy: "9",
  rx: "8.127",
  ry: "8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.627 9.915c-.899.119-1.6.31-2.103.574-.504.263-1.205.807-2.103 1.63.33-1.442.908-2.565 1.736-3.369.828-.804 1.65-1.209 2.47-1.215h0V5.5l4.567 3L8.627 12z",
  fill: "#00497a"
}))));